export default __webpack_public_path__ + "static/media/besfits.0dba4142.jpg";